import { UndefinedAble } from 'data/base';
import { Environment, EnvironmentIdentifier } from './Environment';

export interface AppConfigIdentifier {
  id: string;
}

export interface AppConfigDescription {
  isActive: boolean;
  env: Environment;
  data: AppConfigData;
  extra: object;
}

export interface AppConfig extends AppConfigIdentifier, AppConfigDescription {
  createdAt: Date;
  updatedAt: Date;
}

export interface AppConfigData {
  '@type': 'type.googleapis.com/terra.v1.AppConfigData';
  showLogs: boolean;
}

export interface CreateAppConfigRequest {
  isActive: boolean;
  env: EnvironmentIdentifier;
  data: AppConfigData;
  extra: object;
}

export function createAppConfigTemplate(
  env: Environment,
  appConfig: UndefinedAble<AppConfig>
): AppConfigDescription {
  if (appConfig) {
    return {
      ...appConfig,
      data: createBlankAppConfigData(appConfig),
    };
  } else {
    return createBlankAppConfig(env);
  }
}

export function createBlankAppConfig(env: Environment): AppConfigDescription {
  return {
    isActive: true,
    env,
    data: {
      '@type': 'type.googleapis.com/terra.v1.AppConfigData',
      showLogs: false,
    },
    extra: {},
  };
}

export function createBlankAppConfigData(appConfig: AppConfig): AppConfigData {
  return appConfig.data
    ? appConfig.data
    : {
        '@type': 'type.googleapis.com/terra.v1.AppConfigData',
        showLogs: false,
      };
}
